import { render, staticRenderFns } from "./FeatureAiGenerate.vue?vue&type=template&id=6bbd9af6"
import script from "./FeatureAiGenerate.vue?vue&type=script&lang=js"
export * from "./FeatureAiGenerate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports